import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Chat as ChatIcon } from '@mui/icons-material';

const StartChatButton = ({
  userName,
  userEmail,
  isPending,
  onStartChat,
}) => {
  return (
    <Box className="start-chat-button-container" sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 3,
      height: '100%',
      textAlign: 'center',
    }}>
      <ChatIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
      <Typography variant="h6" className="start-chat-title" sx={{ mb: 1 }}>
        Welcome, {userName}!
      </Typography>
      <Typography variant="body2" className="start-chat-subtitle" sx={{ mb: 3, color: 'text.secondary' }}>
        Ready to start a conversation? Click the button below to begin chatting with our support team.
      </Typography>
      <Button
        variant="contained"
        size="large"
        fullWidth
        className="start-chat-button"
        disabled={isPending}
        onClick={onStartChat}
        sx={{
          maxWidth: '280px',
          py: 1.5,
        }}
      >
        {isPending ? 'Starting Chat...' : 'Start Chat'}
      </Button>
    </Box>
  );
};

export default StartChatButton;
